"use client";

import { useState } from "react";
import { McpSetupHero } from "./mcp-setup-hero";
import { McpSetupGuide } from "./mcp-setup-guide";
import { DEFAULT_MCP_CLIENT, type McpClientId } from "../../lib/mcp-clients";

// // // //

/**
 * McpSetupGuideTab
 * Two-column setup guide: marketing hero on the left, instructions on the right.
 * Owns the selected-client state so the hero's "Connect now" button and the
 * guide's segmented control stay in sync.
 */
export function McpSetupGuideTab(props: {
    onConnect: (client: McpClientId) => void;
}) {
    const { onConnect } = props;

    const [selectedClient, setSelectedClient] =
        useState<McpClientId>(DEFAULT_MCP_CLIENT);

    return (
        <div className="grid grid-cols-1 items-start gap-10 lg:grid-cols-2 lg:gap-12 xl:gap-16">
            <McpSetupHero onConnectClick={() => onConnect(selectedClient)} />
            <McpSetupGuide
                selectedClient={selectedClient}
                onSelectClient={setSelectedClient}
            />
        </div>
    );
}
